import Vue from "vue"
import { Component, Prop, Emit } from "vue-property-decorator"

@Component({
})

export default class HorizontalFormGroup extends Vue {
    @Prop()
    public title: string;
    @Prop()
    public value: string;

    @Prop({ default: "col-sm-2" })
    public labelClass: string;
    @Prop({ default: "col-sm-10" })
    public divClass: string;

    constructor() {
        super();
    }
}